import { cn } from "@/lib/utils";

export const ease = [0.22, 1, 0.36, 1];

// CSS-basierte Einblendung – unabhängig von requestAnimationFrame/JS,
// daher auch im iOS-Stromsparmodus zuverlässig und immer sichtbar am Ende.
export const FadeUp = ({ children, className, delay = 0, as = "div", ...rest }) => {
  const Comp = as;
  return (
    <Comp className={cn("reveal-up", className)} style={delay ? { animationDelay: `${delay}s` } : undefined} {...rest}>
      {children}
    </Comp>
  );
};

export const Lines = ({ lines, className, lineClass, delay = 0, as = "h2", ...rest }) => {
  const Tag = as;
  return (
    <Tag className={className} {...rest}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
          <span className={cn("reveal-line", lineClass)} style={{ animationDelay: `${delay + i * 0.11}s` }}>
            {l}
          </span>
        </span>
      ))}
    </Tag>
  );
};

export const Stagger = ({ children, className }) => (
  <div className={cn("reveal-stagger", className)}>{children}</div>
);
